// extracted by mini-css-extract-plugin
export default {"ok":"valid_ok__zRuir","err":"valid_err__0Evho","load":"valid_load__DKt1n"};